module.exports = __webpack_public_path__ + "static/mo10-e103e42d50479d2b747cdf53a85c44eb.png";